module.exports = __webpack_public_path__ + "img/wz-3-5.fd889599.jpg";